import { useEffect } from "react"
import { useNavigate } from 'react-router-dom'
import axios from "axios"

function DettagliEvento({ idEvento, preferitiCuore, onDataSubmit, opaco, incorpora, img }) {
    const navigate = useNavigate()
    const dettagli = async () => {
        try {
            const res = await axios.get(`/getEventoById/${idEvento}/${localStorage.getItem('email')}`)
            if (res.data === 'failed') navigate('/')
            if (res.data.img) img(res.data.img.split(','))
            if (res.data.incorporaUrl) {

            const urlString = res.data.incorporaUrl
                let videoId = ''
                try {
                    const urlObj = new URL(urlString)
                    if (urlObj.hostname.includes('youtu.be')) {
                        videoId = urlObj.pathname.substring(1)
                    } else if (urlObj.hostname.includes('youtube.com')) {
                        videoId = urlObj.searchParams.get('v')
                        if (!videoId && urlObj.pathname.startsWith('/embed/')) {
                            videoId = urlObj.pathname.split('/')[2]
                        }
                    }
                } catch (e) {
                    videoId = urlString
                }
                if (videoId) {
                    videoId = videoId.split('?')[0].split('&')[0];
                }    
                incorpora(videoId)
            }
            onDataSubmit(res.data)
            res.data.accettazione === 'null' && opaco(0.6)
        } catch (err) { console.log(err) }
    }

    useEffect(() => { dettagli() }, [idEvento])//id (parametro) è l'evento cliccato da home, da cosa fare ecc.
}
export default DettagliEvento